"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const authActions_1 = require("./routing/authActions");
const homeActions_1 = require("./routing/homeActions");
const aiActions_1 = require("./routing/aiActions");
const audioActions_1 = require("./routing/audioActions");
const aclActions_1 = require("../app/acl_module/config/routing/aclActions");
const companyActions_1 = require("./routing/companyActions");
const userActions_1 = require("./routing/userActions");
const userGroupActions_1 = require("./routing/userGroupActions");
const conversationActions_1 = require("./routing/conversationActions");
const messageActions_1 = require("./routing/messageActions");
const avatarActions_1 = require("./routing/avatarActions");
const accountGradeActions_1 = require("./routing/accountGradeActions");
const styleActions_1 = require("./routing/styleActions");
const knowledgeActions_1 = require("./routing/knowledgeActions");
const trainingActions_1 = require("./routing/trainingActions");
const branchActions_1 = require("./routing/branchActions");
const professionActions_1 = require("./routing/professionActions");
const stepActions_1 = require("./routing/stepActions");
const onboardingActions_1 = require("./routing/onboardingActions");
const questionActions_1 = require("./routing/questionActions");
const answerActions_1 = require("./routing/answerActions");
const settingsActions_1 = require("./routing/settingsActions");
const reportsActions_1 = __importDefault(require("./routing/reportsActions"));
const fileActions_1 = require("./routing/fileActions");
const paymentActions_1 = require("./routing/paymentActions");
const currencyActions_1 = require("./routing/currencyActions");
const botTestActions_1 = require("./routing/botTestActions");
const tutorialActions_1 = require("./routing/tutorialActions");
const todoActions_1 = require("./routing/todoActions");
const dblogsActions_1 = require("./routing/dblogsActions");
const whatsappActions_1 = require("./routing/whatsappActions");
const socialMediaPlanActions_1 = require("./routing/socialMediaPlanActions");
const socialMediaPostActions_1 = require("./routing/socialMediaPostActions");
const pgCronActions_1 = require("./routing/pgCronActions");
const digitalWorkerRoutes_1 = require("./routing/digitalWorkerRoutes");
const routes = [
    {
        prefix: '/',
        controllerName: 'home',
        routes: homeActions_1.homeRoutes
    },
    {
        prefix: '/api/ai',
        controllerName: 'ai',
        routes: aiActions_1.aiRoutes
    },
    {
        prefix: '/api/file',
        controllerName: 'file',
        routes: fileActions_1.fileRoutes
    },
    {
        prefix: '/api/audio',
        controllerName: 'audio',
        routes: audioActions_1.audioRoutes
    },
    {
        prefix: '/api/auth',
        controllerName: 'auth',
        routes: authActions_1.authRoutes
    },
    {
        prefix: '/api/acl',
        controllerName: 'acl-policy',
        routes: aclActions_1.aclRoutes
    },
    {
        prefix: '/api/company',
        controllerName: 'company',
        routes: companyActions_1.companyRoutes
    },
    {
        prefix: '/api/avatar',
        controllerName: 'avatar',
        routes: avatarActions_1.avatarRoutes
    },
    {
        prefix: '/api/account-grade',
        controllerName: 'accountGrade',
        routes: accountGradeActions_1.accountGradeRoutes
    },
    {
        prefix: '/api/style',
        controllerName: 'style',
        routes: styleActions_1.styleRoutes
    },
    {
        prefix: '/api/user',
        controllerName: 'user',
        routes: userActions_1.userRoutes
    },
    {
        prefix: '/api/user-group',
        controllerName: 'user-group',
        routes: userGroupActions_1.userGroupRoutes
    },
    {
        prefix: '/api/conversation',
        controllerName: 'conversation',
        routes: conversationActions_1.conversationRoutes
    },
    {
        prefix: '/api/message',
        controllerName: 'message',
        routes: messageActions_1.messageRoutes
    },
    {
        prefix: '/api/knowledge',
        controllerName: 'knowledge',
        routes: knowledgeActions_1.knowledgeRoutes.knowledge
    },
    {
        prefix: '/api/project',
        controllerName: 'project',
        routes: knowledgeActions_1.knowledgeRoutes.project
    },
    {
        prefix: '/api/trainer',
        controllerName: 'trainer',
        routes: trainingActions_1.trainingRoutes
    },
    {
        prefix: '/api/branch',
        controllerName: 'branch',
        routes: branchActions_1.branchRoutes
    },
    {
        prefix: '/api/profession',
        controllerName: 'profession',
        routes: professionActions_1.professionRoutes
    },
    {
        prefix: '/api/step',
        controllerName: 'step',
        routes: stepActions_1.stepRoutes
    },
    {
        prefix: '/api/onboarding',
        controllerName: 'onboarding',
        routes: onboardingActions_1.onboardingRoutes
    },
    {
        prefix: '/api/question',
        controllerName: 'question',
        routes: questionActions_1.questionRoutes
    },
    {
        prefix: '/api/answer',
        controllerName: 'answer',
        routes: answerActions_1.answerRoutes
    },
    {
        prefix: '/api/settings',
        controllerName: 'settings',
        routes: settingsActions_1.settingsRoutes
    },
    {
        prefix: '/api/reports',
        controllerName: 'reports',
        routes: reportsActions_1.default
    },
    {
        prefix: '/api/payment',
        controllerName: 'payment',
        routes: paymentActions_1.paymentActions
    },
    {
        prefix: '/api/currency',
        controllerName: 'currency',
        routes: currencyActions_1.currencyRoutes
    },
    {
        prefix: '/api/bot-test',
        controllerName: 'bot-test',
        routes: botTestActions_1.botTestRoutes
    },
    {
        prefix: '/api/tutorial',
        controllerName: 'tutorial',
        routes: tutorialActions_1.tutorialRoutes
    },
    {
        prefix: '/api/todo',
        controllerName: 'todo',
        routes: todoActions_1.todoRoutes
    },
    {
        prefix: '/api/dblogs',
        controllerName: 'dblogs',
        routes: dblogsActions_1.dblogsRoutes
    },
    {
        prefix: '/api/whatsapp',
        controllerName: 'whatsapp',
        routes: whatsappActions_1.whatsappRoutes
    },
    {
        prefix: '/api/social-media-plan',
        controllerName: 'social-media-plan',
        routes: socialMediaPlanActions_1.socialMediaPlanRoutes
    },
    {
        prefix: '/api/social-media-post',
        controllerName: 'social-media-post',
        routes: socialMediaPostActions_1.socialMediaPostRoutes
    },
    {
        prefix: '/api/cron',
        controllerName: 'pgCron',
        routes: pgCronActions_1.pgCronActions
    },
    {
        prefix: '/api/digital-worker',
        controllerName: 'digital-worker',
        routes: digitalWorkerRoutes_1.digitalWorkerRoutes
    }
];
exports.default = routes;
